import useLang from "hooks/useLang";
import styles from "./LangToggle.module.scss";

const LangToggle = () => {
  const { mode, setLang } = useLang();

  return (
    <div className={styles.langSwitch}>
      <span className={mode === "ID" ? "active" : ""} onClick={() => setLang("ID")}>
        ID
      </span>
      |
      <span className={mode === "EN" ? "active" : ""} onClick={() => setLang("EN")}>
        EN
      </span>
    </div>
  );
};

export default LangToggle;
